import { swSettings } from "app/common/services/swSettings";
import dayjs from "dayjs";

export const getAlgoChangeDataTimestamp = (): number => {
    const algoChangeDateString = swSettings.components.CustomSegments.resources.algoChangeDate;
    const algoChangeDate = dayjs.utc(algoChangeDateString);
    return algoChangeDate.valueOf();
};
